import { Component, Input, OnInit } from '@angular/core';
import { FinancialTransactionFilter } from 'app/shared/filters/financial-transaction.filter';
import { FinancialTransactionService } from '../../../shared/services/financial-transaction.service';
import { FinancialTransactionBase } from '../../models/financial-transaction-base.model';

@Component({
  selector: 'app-module-financial-transactions',
  templateUrl: './module-financial-transactions.component.html',
  styleUrls: ['./module-financial-transactions.component.scss']
})
export class ModuleFinancialTransactionsComponent implements OnInit {

  @Input() moduleId: number;
  @Input() currentObjectId: number;

  financialTransactionFilter: FinancialTransactionFilter;
  financialTransactions: FinancialTransactionBase[];

  constructor(protected financialTransactionService: FinancialTransactionService) {
  }

  ngOnInit() {
    this.financialTransactionFilter = new FinancialTransactionFilter(null, null, null, this.currentObjectId);
    this.financialTransactionService.getCollection<FinancialTransactionBase>("/financial-transaction/" + this.moduleId + "/" + this.currentObjectId, null, (collection) => this.financialTransactions = collection);
  }
}
